import React, { Component } from 'react';
import {
	DialogContent,
	DialogTitle,
	DialogFooter,
	DialogClose,
	DialogHeader,
} from '@/components/ui/dialog';
import { Checkbox } from '@/components/ui/checkbox';
import { Button } from '@/components/ui/button';
import { LEGAL_AGREEMENT_PATHS } from '@/components/legal/agreementPaths';

class AIDialog extends Component {
	state = {
		hasAgreedToTerms: false,
	};

	handleHasAgreedToTerms = (isChecked) => {
		this.setState({ hasAgreedToTerms: isChecked });
	};

	handleAgree = async () => {
		if (!this.state.hasAgreedToTerms || this.props.saving) return;
		await this.props.handleAgreedPopupDialog();
	};

	renderMessageLines() {
		return (
			<div className="grid gap-2">
				<p className="text-sm">
					AI Enhancement helps you draft and refine messages before you
					send them — expand, shorten, adjust tone, spell-check, and
					generate text. Please review and accept the agreement below
					before you start.
				</p>
				<label className="flex items-start gap-3 max-md:py-1">
					<Checkbox
						checked={this.state.hasAgreedToTerms}
						onCheckedChange={this.handleHasAgreedToTerms}
						disabled={this.props.saving}
					/>
					<span className="text-sm leading-snug">
						I have reviewed and agree to the{' '}
						<a
							href={LEGAL_AGREEMENT_PATHS.aiPlatformUseAgreement}
							target="_blank"
							rel="noopener noreferrer"
							className="underline text-primary hover:no-underline"
						>
							AI Message Enhancement Agreement
						</a>
						.
					</span>
				</label>
			</div>
		);
	}

	render() {
		const { saving } = this.props;

		return (
			<DialogContent>
				<DialogHeader>
					<DialogTitle>AI Message Enhancement Agreement</DialogTitle>
				</DialogHeader>
				<div className="flex flex-col">
					<div>{this.renderMessageLines()}</div>
				</div>
				<DialogFooter>
					<DialogClose asChild>
						<Button variant="ghost" disabled={saving}>
							Cancel
						</Button>
					</DialogClose>
					<Button
						disabled={!this.state.hasAgreedToTerms || saving}
						onClick={this.handleAgree}
					>
						{saving ? 'Saving…' : 'Agree'}
					</Button>
				</DialogFooter>
			</DialogContent>
		);
	}
}

export default AIDialog;
